import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Apps from '../components/Apps';
import Contact from '../components/Contact';

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Apps />
      <Contact />
    </>
  );
}

export default HomePage;
